import SectionItem from "./SectionItem";

const languageProficiencies: { [key: string]: string } = {
  ELEMENTARY: "Elementary proficiency",
  LIMITED_WORKING: "Limited working proficiency",
  PROFESSIONAL_WORKING: "Professional working proficiency",
  FULL_PROFESSIONAL: "Full professional proficiency",
  NATIVE_OR_BILINGUAL: "Native or bilingual proficiency",
};
export default function Languages({
  languages,
}: {
  languages: { name: string; proficiency: string }[];
}) {
  return (
    <>
      {languages.map(({ proficiency, name }) => (
        <SectionItem key={`${name}-${proficiency}`}>
          <div className="flex flex-col gap-y-0.5">
            <span className="text-sm-bold">{name}</span>
            <span className="text-xs-medium text-black-500">
              {languageProficiencies[proficiency]}
            </span>
          </div>
        </SectionItem>
      ))}
    </>
  );
}
